import { Injectable, OnDestroy } from '@angular/core';
import { AnalyticsService } from '@laasy/common-layout';
import { BehaviorSubject, Observable } from 'rxjs';
import { SegmentEvent } from '../../utilities/constants';
import { error_msg, warning_msg } from 'src/app/modules/auth/auth-constants';

@Injectable({
  providedIn: 'root'
})
export class ToastService implements OnDestroy {
  toastSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  timeoutId!: NodeJS.Timeout;
  toast$: Observable<any> = this.toastSubject.asObservable();

  constructor(private analyticsService: AnalyticsService){}

  setToast(msg: any) {
    this.clearToastTimeout();
    if(msg && (msg.heading || msg.text))
      this.analyticsService.segmentTrackEvent( { ...msg}, SegmentEvent.toast);
    this.toastSubject.next(msg);
    // clear toast after 1 minute to avoid irrelevant toast
    this.timeoutId = setTimeout(() => {
      this.clearToast();
    }, 60 * 1000);
  }

  clearToast() {
    this.toastSubject.next(null);
    this.clearToastTimeout();
  }

  ngOnDestroy() {
    this.clearToastTimeout();
  }

  private clearToastTimeout() {
    if (this.timeoutId)
      clearTimeout(this.timeoutId);
  }

  errorToast(msg: any,heading:string= 'Error') {
    this.setToast({ ...error_msg,heading: heading, text: msg });
  }

  warnToast(msg: any,heading:string= 'Warning') {
    this.setToast({ ...warning_msg,heading: heading, text: msg });
  }


}
